import {Injectable, Injector} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {ErrorService} from '../providers/error.service';
import {Observable, throwError} from 'rxjs';
import {catchError, distinctUntilChanged} from 'rxjs/operators';
import {UserService} from '../providers/user.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(public _injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      distinctUntilChanged(),
      catchError((err: HttpErrorResponse) => {
        // Inject Services
        const errorService = this._injector.get(ErrorService);
        const userService = this._injector.get(UserService);

        // upgradeable solution ...
        switch (err.status) {
          case 0: {
            userService.logout(true);
            errorService.showErrorWithCode(err.status);
            break;
          }
          // Bad Request
          case 400: {
/*            errorService.showErrorWithCode(err.status);*/
            break;
          }
          // Unauthorized
          case 401: {
            userService.logout(true);
/*            errorService.showErrorWithCode(err.status);*/
            break;
          }
          // Payment Required
          case 402: {
            /*errorService.showErrorWithCode(err.status);*/
            break;
          }
          // Forbidden
          case 403: {
            /*errorService.showErrorWithCode(err.status);*/
            break;
          }
          // Not Found
          case 404: {
/*            errorService.showErrorWithCode(err.status);*/
            break;
          }
          // Method Not Allowed
          case 405: {
            /*errorService.showErrorWithCode(err.status);*/
            break;
          }
          // ...
          // mostly 500 backend errors...
          default: {
            userService.logout(true);
            errorService.showErrorWithCode(err.status);
            break;
          }
        }

        return throwError(() =>err);
      })
    );
  }

}
